import gql from "graphql-tag";

import {ServerErrors, TimezoneInfo} from "@/lib/types/common.ts";

export interface NewResourceResult {
  id?: number;
  success: boolean;
  errors: ServerErrors;
}

export interface EnumItem {
  value: string;
  label: string;
}

export interface TimezoneResult {
  timezones: TimezoneInfo[];
}

export const GENERIC_MUTATION_RESPONSE_FIELDS = `
  ... on GenericMutationResponseSuccess {
    status
  }
  ... on ErrorResponse {
    status
    message
  }
`;

export const GQL_MARKDOWN_RENDER = gql`
  query RenderMarkdown($markdown: String!) {
    renderMarkdown(markdown: $markdown) {
      data
    }
  }
`;

export const GQL_TIMEZONES = gql`
  query GetTimezones {
    timezones {
      name
      city
      base_offset_display
    }
  }
`;
